import { GrDocumentPdf } from 'react-icons/gr';
import Grid from '../components/Grid';
import { AttachmentInput, DBSelectInput, GroupInput, Input, InputCurrency } from '../components/Input';
import { useSystemContext } from '../Context/SystemContext';

const yup = require('../interface/yup-br');

export const LicitaEmpenho = () => {
    const System = useSystemContext();
    /*
    async function _downloadFile(file) {
        const fileinfo = await System.apiGetFileInfo(file);
        const Ext = fileinfo.filename.split('.').pop();
        System.apiGetRawFile(file).then(async (response) => {
            if (response.status === 200) {
                fileDownload(response.data, file + '.' + Ext);
            }
        });
    }
    */

    const _ViewFile = async (file) => {
        const arq = await System.apiGetFile(file);
        const f = await System.apiGetFileInfo(file);
        const ufile = new Blob([arq], { type: f.metadata.contentType });
        // Outra lógica para exibir outros tipos de arquivos
        window.open(URL.createObjectURL(ufile));
    }

    const formatStrCurrency = (value) => {
        return `R$ ${parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }

    return (
        <Grid
            url={'/licitaempenho'}
            perms={'100'}
            disableModal={true}
            GridHeaders={[
                { title: 'Emitente', field: 'emitente', sort: true, className: 'w-5/12' },
                { title: 'Edital vinculado', field: 'edital', sort: false, className: 'w-5/12 text-left pl-1' },
                { title: 'Valor', field: 'valor_total', type: 'currency', sort: true, className: 'w-2/12 text-center' },
            ]}
            GridTitle="Cadastro de Empenho"
            LineDataPrint={(data) => {
                return [
                    data.emitente,
                    data.edital
                        ? <span className="text-green-700">{`${data.edital.numeroLicitacao || 's/ número'} — ${data.edital.contratante || 'sem contratante'}${data.edital.valorOriginal ? ' — ' + data.edital.valorOriginal : ''}`}</span>
                        : <span className="text-red-500">🔴 Vincular edital</span>,
                    formatStrCurrency(data.valor_total),
                ];
            }}
            onRenderForm={(GridModes, SetFieldValue, values) => {
                localStorage.setItem('autoEdit', null);
                return (
                    <>
                        <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                            <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                        </div>
                        {GridModes.insert_mode ? (
                            <div className='p-2'>
                                <GroupInput>
                                    <AttachmentInput name="arquivo" accept="application/pdf" label="Arquivo PDF Empenho" />
                                </GroupInput>
                            </div>
                        ) : (
                            <div className='p-2'>
                                <GroupInput>
                                    <DBSelectInput
                                        name="edital"
                                        label="Edital vinculado (número — contratante — valor)"
                                        url={'/licitaeditalselect'}
                                        displaySelectField="label"
                                        className={'w-full'}
                                    />
                                </GroupInput>
                                <GroupInput>
                                    <Input name="emitente" label="Emitente" />
                                </GroupInput>
                                <GroupInput>
                                    <InputCurrency name="valor_total" label="Valor Total" className={'w-48'} />
                                </GroupInput>
                                <GroupInput>
                                    <Input name="emitente_endereco" label="Endereço" />
                                    <Input name="emitente_complemento" label="Complemento" />
                                </GroupInput>
                                <GroupInput>
                                    <Input name="emitente_bairro" label="Bairro" />
                                    <Input name="emitente_cidade" label="Cidade" />
                                    <Input name="emitente_uf" label="UF" />
                                    <Input name="emitente_cep" label="CEP" />
                                </GroupInput>
                                <GroupInput>
                                    <Input name="emitente_telefone" label="Telefone" />
                                    <Input name="emitente_email" label="E-mail" />
                                </GroupInput>
                                <GroupInput>
                                    <div className='p-4 m-2 border rounded-md cursor-pointer bg-botao-primario text-botao-primario-fonte hover:bg-botao-primario-hover hover:text-botao-primario-fonte'
                                        onClick={() => _ViewFile(values.arquivo)} >
                                        <GrDocumentPdf className="inline-flex w-6 h-6 text-gray-500 cursor-pointer hover:text-gray-700" />
                                        <span className='pl-2'>Visualizar Empenho original</span>
                                    </div>
                                </GroupInput>

                            </div>
                        )}
                    </>
                );
            }}
            FormTabs={
                [
                    () => {
                        return <div>Empenho</div>;
                    },
                    () => {
                        return <div>Itens do edital</div>;
                    },
                ]}

            onRenderFormExtra={
                [
                    (GridModes, item) => {
                        return (
                            <div>
                                {!GridModes.insert_mode && (
                                    <div className={'m-2'}>
                                        <Grid
                                            url={'/licitaempenhoitems'}
                                            url_get_all={'/licitaempenhoitems/' + item._id}
                                            perms={'100'}
                                            disableModal={true}
                                            hideIndexColumn={true}
                                            canInsert={false}
                                            canDelete={false}
                                            GridTitle="Itens do empenho (importados do edital)"
                                            GridHeaders={[
                                                { title: 'Descrição', field: 'descricao', sort: true, className: 'w-5/12 text-left pl-1' },
                                                { title: 'Unidade', field: 'unidade', sort: true, className: 'w-1/12 text-center' },
                                                { title: 'Qtd Original', field: 'quantidadeOriginal', type: 'number', sort: true, className: 'w-2/12 text-center' },
                                                { title: 'Qtd Atendida', field: 'quantidade', type: 'number', sort: true, className: 'w-2/12 text-center' },
                                                { title: '% Atendido', field: 'percentual', type: 'number', sort: true, className: 'w-2/12 text-center' },
                                            ]}
                                            LineDataPrint={(data) => {
                                                return [
                                                    data.descricao,
                                                    data.unidade,
                                                    String(data.quantidadeOriginal ?? 0),
                                                    String(data.quantidade ?? 0),
                                                    `${(data.percentual ?? 0).toFixed(1)}%`,
                                                ];
                                            }}
                                            onRenderForm={() => {
                                                return (
                                                    <div className="p-2">
                                                        <GroupInput>
                                                            <Input name="descricao" label="Descrição do item" disabled />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <Input name="quantidadeOriginal" type="number" label="Qtd no edital" className={'w-40'} disabled />
                                                            <Input name="unidade" label="Unidade" className={'w-32'} disabled />
                                                            <Input name="quantidade" type="number" label="Qtd atendida neste empenho" className={'w-56'} />
                                                        </GroupInput>
                                                    </div>
                                                );
                                            }}
                                            validationSchema={
                                                yup.object().shape({
                                                    quantidade: yup.number().typeError('Informe um número').min(0, 'Não pode ser negativo').max(yup.ref('quantidadeOriginal'), 'Não pode exceder a quantidade do edital'),
                                                })
                                            }
                                        />

                                    </div>
                                )}
                            </div>
                        );
                    }
                ]
            }


            validationSchema={
                yup.object().shape({})
            }
        />

    );
}